export default "__VITE_ASSET__490e059c__"